import React from 'react';
import { Formik } from 'formik';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { useParams } from 'react-router-dom';

import FormWrapper from '~FormWrapper';
import SpaceMaintenanceForm from './SpaceMaintenanceForm';

import {
  getUserOrdererOrganizationPhone,
  getUserOrdererOrganizationId,
} from '~features/user/ducks';

import { useOnSubmit } from '~hooks/useOnSubmit';
import { useOnEdit } from '~hooks/useOnEdit';
import { removeEmptyKeys, isPhoneNumberValid } from '../validations';

const validate = values => {
  const errors = {};

  if (!values.type) {
    errors.type = 'Vaadittu';
  }

  if (!values.space) {
    errors.space = 'Vaadittu';
  }

  if (!values.description) {
    errors.description = 'Vaadittu';
  }

  errors.contactPhone = isPhoneNumberValid(values.contactPhone);

  return removeEmptyKeys(errors);
};

const SpaceMaintenance = props => {
  const { formId, edit } = props;
  const { orderId } = useParams();

  const organizations = useSelector(state => state.reducer.organizations);
  const userPhone = useSelector(state =>
    getUserOrdererOrganizationPhone(state)
  );
  const userOrganizationId = useSelector(state =>
    getUserOrdererOrganizationId(state)
  );

  const userOrganization = organizations?.find(
    o => o.id === userOrganizationId
  );

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  return (
    <Formik
      initialValues={{
        type: null,
        space: null,
        isUrgent: false,
        description: '',
        // collectFeedback: true,
        contactPhone: userPhone || '',
        infectionRisk: false,
        attachmentInput: [],
      }}
      validate={validate}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        const method = edit ? onFormEdit : onFormSubmit;
        await method({
          fields: {
            ...values,
            attachmentInput: values.attachmentInput.map(a => ({ id: a.id })),
          },
          setSubmitting,
          orderId,
          formId,
        });
      }}
    >
      {formikProps => (
        <FormWrapper
          {...props}
          title="Tilahuolto"
          organizations={organizations}
          userOrganization={userOrganization}
          formik={formikProps}
          Component={SpaceMaintenanceForm}
        />
      )}
    </Formik>
  );
};

export default SpaceMaintenance;
